import { useAppSelector } from 'shared';

export const usePlacesPageState = (
    () => useAppSelector((store) => store.placesPage)
);
